import PropTypes from 'prop-types'
import React, { useContext } from 'react'

import ButtonScrollDown from 'components/ButtonScrollDown'
import { GOODS_TYPES } from 'constants/sales'
import AddAndGoToCart from 'containers/AddAndGoToCart'
import CostContainerSale from 'containers/CostContainerSale'
import { FeaturesContext } from 'contexts/Features'
import { MenuMainContext } from 'contexts/MenuMain'
import { TextLH, H1Small as H1 } from 'styles/components/typography'

import DnaEffect from './components/DnaEffect'
import { FirstBlockWrapperStyled } from './styles'

const DResultsFirst = ({ data, secondBlockRef }) => {
  const { restrictUIX } = useContext(FeaturesContext)
  const { isSalesBanner, salesBannerHeight } = React.useContext(MenuMainContext)

  return (
    <FirstBlockWrapperStyled
      isExtraTopIndent={isSalesBanner}
      indentHeight={salesBannerHeight}
      className="pb-2 pb-md-4"
      beforeElement={
        <div className="position--full">
          {restrictUIX.noWebGL === null ? null : (
            <DnaEffect restrictUIX={restrictUIX} />
          )}
        </div>
      }
    >
      <div className="first-content-top-indent row">
        <div className="col-12 offset-md-6 col-md-6 offset-lg-4 col-lg-8">
          <H1 dangerouslySetInnerHTML={{ __html: data.title }} />

          <div className="d-inline-block max-w--80p">
            <TextLH dangerouslySetInnerHTML={{ __html: data.content }} />
          </div>

          <div className="pt-3 pt-md-4">
            <div className="d-flex align-items-center">
              <AddAndGoToCart
                goods={[
                  {
                    type: GOODS_TYPES.dna,
                    isSubscription: false,
                  },
                ]}
                buttonProps={{
                  bgClassName: 'bg--green',
                  withTopMarginOnMobile: true,
                }}
                buttonTitleKey={'order_test'}
                forceMultipleAdd={true}
              />

              <CostContainerSale
                className="ml-15"
                productType={GOODS_TYPES.dna}
                isMobileCenter={true}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12 pt-4">
          <ButtonScrollDown
            title={data.go_to_site}
            refToScroll={secondBlockRef}
          />
        </div>
      </div>
    </FirstBlockWrapperStyled>
  )
}

DResultsFirst.propTypes = {
  data: PropTypes.object.isRequired,
  secondBlockRef: PropTypes.object.isRequired,
}

export default DResultsFirst
